import { render, staticRenderFns } from "./Shoe.vue?vue&type=template&id=432a8a56&scoped=true&"
import script from "./Shoe.vue?vue&type=script&lang=js&"
export * from "./Shoe.vue?vue&type=script&lang=js&"
import style0 from "./Shoe.vue?vue&type=style&index=0&id=432a8a56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432a8a56",
  null
  
)

export default component.exports